import { Provider } from '../types';
import { isActiveProviderBridge } from './providerBridgeUtils';

// Mirrors the backend's group_by_status ranking (DenimCommon list_providers):
// 0 = on PAC, 1 = not on PAC, 2 = terminated (no currently active practice
// affiliation). Providers with more than one practice bridge take the best
// (lowest) rank across all of them.
export const getProviderStatusRank = (provider: Provider): number => {
  const bridges = provider.providerBridge || [];
  if (!bridges.length) return 2;

  const ranks = bridges.map((bridge) => {
    if (!isActiveProviderBridge(bridge)) return 2;
    return bridge.onPac ? 0 : 1;
  });

  return Math.min(...ranks);
};
